import { render, staticRenderFns } from "./customer-registration.vue?vue&type=template&id=12a05275&"
import script from "./customer-registration.vue?vue&type=script&lang=js&"
export * from "./customer-registration.vue?vue&type=script&lang=js&"
import style0 from "./customer-registration.vue?vue&type=style&index=0&id=12a05275&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports